// Libraries
import { Component} from "react";
import { Routes, Route } from "react-router-dom";

// Components
import HamburgerMenu from "./components/HamburgerMenu";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

// Pages
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import SoF from "./pages/SoF";

// Assets
import "./assets/styles/App.css";

class App extends Component {
  render(){
    return (
      <div id="wrapper">
        <NavBar/>
        <HamburgerMenu />
        <Routes>
          <Route index element={<Home />} />
          <Route path="/" exact element={<Home />} />
          <Route path="about" exact element={<About />} />
          <Route path="contact" exact element={<Contact />} />
          <Route path="statement_of_faith" exact element={<SoF />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </div>
    );
  };
};

export default App;
